const Input = ({ label, type, name, placeholder, value, onChange, error, className, required = true }) => (
  <div className="t-w-full">
    <label htmlFor={name}>{label}</label>

    <div className="t-relative">
      <input
        id={name}
        name={name}
        type={type ?? 'text'}
        autoComplete={name}
        className={`t-w-full t-px-2 t-py-2 t-rounded-md t-border t-border-gray-300 t-focus:outline-none t-focus:ring-2 t-focus:ring-tertiary t-text-gray-900 t-placeholder-gray-400 ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        aria-invalid={!!error}
        aria-describedby={error ? 'login-error' : undefined}
      />

      {error && (
        <div
          id="login-error"
          className="t-text-red-600 t-text-sm t-mt-1 t-mb-2"
          role="alert"
          aria-live="assertive"
        >
          {error}
        </div>
      )}
    </div>
  </div>
);

export default Input;
